export type AppView = 'lobby' | 'workout' | 'talent-tree' | 'history' | 'gear' | 'shop';
export type SecondaryView = 'gear' | 'talent-tree' | 'shop';
export type PrimaryView = 'lobby' | 'history';
export type UrlNavigationMode = 'push' | 'replace';

export interface AppHistoryState {
  appView?: AppView;
  origin?: PrimaryView;
  returnViaHistory?: boolean;
}

export function getSecondaryView(search: string): SecondaryView | null {
  const view = new URLSearchParams(search).get('view');
  return view === 'gear' || view === 'shop' ? view : view === 'talents' ? 'talent-tree' : null;
}

export interface WorkoutAppHistoryState extends AppHistoryState {
  appView: 'workout';
  origin: PrimaryView;
  returnViaHistory: boolean;
}

export function createWorkoutAppHistoryState(
  origin: PrimaryView,
  mode: UrlNavigationMode,
): WorkoutAppHistoryState {
  return {
    appView: 'workout',
    origin,
    returnViaHistory: mode === 'push',
  };
}

export function shouldReturnToWorkoutOriginViaHistory(
  state: unknown,
  origin: PrimaryView,
): boolean {
  if (!state || typeof state !== 'object') return false;

  const historyState = state as Partial<WorkoutAppHistoryState>;
  return historyState.appView === 'workout'
    && historyState.origin === origin
    && historyState.returnViaHistory === true;
}
